import { createAsyncThunk } from '@reduxjs/toolkit';

import { getPlanListService } from 'services/plan.service';

export const getPlans = createAsyncThunk(
  'plan/getPlans',
  async (_, thunkApi) => {
    try {
      const response = await getPlanListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
